import * as React from 'react';
import * as anime from 'animejs';

export class Homepage extends React.Component {
  componentDidMount() {
    /* Animate splash header of the section to have a nice fade in */
    const splashAnimation = anime.timeline();

    splashAnimation.add({
      targets: 'main',
      opacity: [0, 1],
      duration: 800,
      delay: 800,
      easing: 'easeOutQuint'
    });
  }

  render() {
    return (
      <section>
        <section className="wrapper">
          <div className="copy">
            <h6 className="t-delta u-opacity--90">
              The group consists of several independent companies involved in
              forestry and wood processing industry.
            </h6>
            <p className="t-epsilon u-opacity--60">
              All the products of our group of companies are derived from unique
              140 year old Slavonian oak trees of the highest quality that grow
              in our private Croatian forests and belong to our group of
              companies.
            </p>
            <div className="copy__body">
              <p className="t-eta u-opacity--60">
                Unlike most of their European neighbours, the Croatian foresters
                in our oak forests operate and work exclusively according to the
                principles of natural regeneration. In that way they follow the
                natural laws of the forest ecosystem. Their focus is on the
                natural life cycle of all plants, insects and animals in the
                forest that together create a mutually supportive system. By
                strictly pursuing the principle „Follow the Nature“, we use only
                the fruits and products that the forest gives us, and solely in
                the form that they are given to us in.
              </p>
              <p className="t-eta u-opacity--60">
                All living beings and plants follow their own purpose and life
                cycle, determined by their biology. They are born, grow and
                eventually age. At the end of their individual lives, our
                Slavonian oaks fulfill the most important task of their life
                cycle. Before they are gone, they leave their fruits deep down
                below them, thus creating a young oak forest. After this task is
                completed, it is time for the parents to give way to the
                children, so that the offspring do not wither in the shadows of
                their ancestors, but instead get a chance to grow in the light
                as a new vital forest.
              </p>
              <p className="t-eta u-opacity--60">
                In auric we therefore accept that a young, growing forest and an
                aged, 140 year old forest have the same worth. They are both a
                part of a closed ecosystem and deserve the same respect.
              </p>
              <p className="t-eta u-opacity--60">
                We aim to make the most of the „natural“ advantage that comes
                out of the „Follow the Nature“ principle for ourselves, our
                environment and our work. Knowing that all plants, living
                creatures and other building blocks of a forest eventually die,
                our foresters put special effort and care into the natural
                regeneration of the forests. In principle, in our forests there
                is no clear-cutting, they are overgrown with forest plants at
                all times. Therefore, it is merely the age, height and the
                number of trees per hectare that makes a difference between an
                old, ready-to-cut forest, and a young, „future“ forest.
                Ultimately, it is only this fleeting optical difference that can
                cause an inexperienced, superficial observer to doubt the
                meaning of the forest life cycle.
              </p>
              <p className="t-eta u-opacity--60">
                The natural architecture of the forest ranges - depending on the
                life stage of the forest - from plants of only few centimeters
                that look like bushes, to a few, thinned and hand-picked
                individual oak trees of up to 35 meters, that in their last
                stage of life resemble natural green cathedrals.
              </p>
            </div>
          </div>
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Routing/views/Homepage.tsx